import { render } from "./ButtonPageUp.vue?vue&type=template&id=420f70a9&scoped=true"
import script from "./ButtonPageUp.vue?vue&type=script&lang=js"
export * from "./ButtonPageUp.vue?vue&type=script&lang=js"

import "./ButtonPageUp.vue?vue&type=style&index=0&id=420f70a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420f70a9"]])

export default __exports__